// reducers.js

const initialState = {
  allMenu: [],
  menuSub: [],
  menuSubList: [],
  menuCard: [],
  menuSubCard: []
}

const allMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ALLMENU':
      return {
        ...state,
        allMenu: action.payload
      }
    case 'SET_MENU_SUB':
      return {
        ...state,
        menuSub: action.payload
      }
    case 'SET_MENU_SUBLIST':
      return {
        ...state,
        menuSubList: action.payload
      }
    case 'SET_MENU_CARD':
      return {
        ...state,
        menuCard: action.payload
      }
    case 'SET_MENU_SUB_CARD':
      return {
        ...state,
        menuSubCard: action.payload
      }
    default:
      return state
  }
}

export default allMenuReducer
